import script from "./EditableChipDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditableChipDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./EditableChipDropdown.vue?vue&type=style&index=0&id=160abd5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-160abd5c"]])

export default __exports__